:host {
  display: block;
}

.cta-area-sticky {
  display: flex;
  align-items: center;
  height: 50px;
}

:host(:not([dir="rtl"])) .cta-area-sticky {
  padding-left: 20px;
  padding-right: 12px;
}

:host([dir="rtl"]) .cta-area-sticky {
  padding-right: 20px;
  padding-left: 12px;
}

.cta-area-sticky__img {
  flex: 1 1 auto;
  max-width: 30px;
  height: 30px;
}

:host(:not([dir="rtl"])) .cta-area-sticky__img {
  margin-right: 12px;
}

:host([dir="rtl"]) .cta-area-sticky__img {
  margin-left: 12px;
}

.cta-area-sticky__price {
  overflow: hidden;
}

:host(:not([dir="rtl"])) .cta-area-sticky__price {
  margin-right: 12px;
}

:host([dir="rtl"]) .cta-area-sticky__price {
  margin-left: 12px;
}

@media screen and (max-width: 979px) {
  .cta-area-sticky__price {
    display: none;
  }
}

.cta-area-sticky__button {
  flex: 0 1 auto;
  display: flex;
  justify-content: flex-end;
  min-width: 0;
  overflow: hidden;
}

:host(:not([dir="rtl"])) .cta-area-sticky__button {
  margin-left: auto;
}

:host([dir="rtl"]) .cta-area-sticky__button {
  margin-right: auto;
}

.cta-area-sticky__quick-actions {
  overflow: hidden;
}